import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';







import { LuArrowLeft, LuArchive, LuTrash2, LuMail, LuEllipsisVertical } from 'react-icons/lu';







const EMPTY_TIMINGS = [];







const normalise = word => word.toLowerCase().replace(/[’‘]/g, "'").replace(/[^\p{L}\p{N}']/gu, '');







// Keep measured speech cues; estimate only script tokens absent from the ASR.







function buildTimeline(narration, wordTimings, duration) {







  const tokens = [...narration.matchAll(/(\S+)(\s*)/g)];







  const script = tokens.map(token=>token[1]);







  // Estimate speech and pauses separately when measured words are unavailable.







  // Paragraph breaks give each narrated detail time to remain highlighted.







  const speechSeconds = .4;







  const pauses = tokens.map(([_,word,space])=>







    (/[.!?]$/.test(word)?.35:/[,;:]$/.test(word)?.12:0) + (/\n\s*\n/.test(space)?.65:0));







  const weights = pauses.map(pause=>speechSeconds+pause);







  const spoken = (Array.isArray(wordTimings) ? wordTimings : []).filter(item =>







    item && typeof item.word === 'string' && Number.isFinite(item.start) && Number.isFinite(item.end) && item.start >= 0 && item.end >= item.start);







  const length = duration > 0 ? duration : spoken.length ? spoken[spoken.length - 1].end : weights.reduce((sum,weight)=>sum+weight,0);







  const mapped = Array(script.length).fill(null);







  if (spoken.length) {







    const rows = script.length + 1, columns = spoken.length + 1;







    const scores = new Uint16Array(rows * columns);







    const source = script.map(normalise), audio = spoken.map(item => normalise(item.word));







    for (let i = 1; i < rows; i += 1) for (let j = 1; j < columns; j += 1) {







      scores[i * columns + j] = source[i - 1] && source[i - 1] === audio[j - 1]







        ? scores[(i - 1) * columns + j - 1] + 1







        : Math.max(scores[(i - 1) * columns + j], scores[i * columns + j - 1]);







    }







    let i = script.length, j = spoken.length;







    while (i > 0 && j > 0) {







      if (source[i - 1] && source[i - 1] === audio[j - 1]) {







        mapped[i - 1] = { ...spoken[j - 1], measured: true }; i -= 1; j -= 1;







      } else if (scores[(i - 1) * columns + j] >= scores[i * columns + j - 1]) i -= 1;







      else j -= 1;







    }







  }







  const measured = mapped.filter(Boolean).length;







  for (let index = 0; index < mapped.length;) {







    if (mapped[index]) { index += 1; continue; }







    const from = index;







    while (index < mapped.length && !mapped[index]) index += 1;







    const start = from ? mapped[from - 1].end : 0;







    const end = Math.max(start, index < mapped.length ? mapped[index].start : length);







    const totalWeight = weights.slice(from,index).reduce((sum,weight)=>sum+weight,0);







    const scale = totalWeight ? (end-start)/totalWeight : 0;







    let cursor = start;







    for (let k = from; k < index; k += 1) {







      mapped[k] = {start:cursor,end:cursor+speechSeconds*scale,measured:false};







      cursor += weights[k]*scale;







    }







  }







  return { words: mapped, mode: measured === script.length ? 'measured' : measured ? 'mixed' : 'estimated' };







}







function wordOffset(narration, phrase) {







  const at = narration.indexOf(phrase);







  if (at < 0) throw new Error(`Missing narration cue: ${phrase}`);







  return narration.slice(0, at).trim().split(/\s+/).filter(Boolean).length;







}







function cueTime(narration, timeline, phrase) {







  return timeline.words[wordOffset(narration, phrase)]?.start ?? Infinity;







}







function buildBeats(narration, timeline, phrases, endPhrase) {







  const script = narration.match(/\S+/g) || [];







  const offsets = phrases.map(phrase => wordOffset(narration, phrase));







  const end = endPhrase ? wordOffset(narration, endPhrase) : script.length;







  return offsets.map((from, index) => ({







    start: timeline.words[from]?.start ?? Infinity,







    text: script.slice(from, offsets[index + 1] ?? end).join(' '),







    timings: timeline.words.slice(from, offsets[index + 1] ?? end).map(word => word.start),







  }));







}







function activeIndex(items, now) {







  let index = 0;







  items.forEach((item, i) => { if (now >= item.start) index = i; });







  return index;







}







// Keep the same timing-input aliases and stable timeline as What Is Tribe.







function useNarrationTimeline(narration, wordTimings, duration) {







  const timingKey = JSON.stringify(Array.isArray(wordTimings)







    ? wordTimings.map(item => [item?.word, item?.start, item?.end]) : []);







  return useMemo(() => buildTimeline(narration, wordTimings, duration), [narration, duration, timingKey]);







}







// Read the audio clock each frame, but render only when a word boundary,







// pause, seek or playback rate changes. Native CSS handles the motion.







function useLessonClock({ time, audioElement, audioRef, playbackId, audioStatus } = {}, timeline) {







  const boundaries = useMemo(() => timeline.words.map(word => word.start), [timeline]);







  const sourceTime = Number.isFinite(time) ? Math.max(0, time) : 0;







  const parentAnchor = useRef({ time: sourceTime, stamp: null });







  const controller = useRef({ time: sourceTime, boundary: -2, playing: false, rate: 1, syncId: 0 });







  const [clock, setClock] = useState({ now: sourceTime, playing: audioStatus === 'Playing', rate: 1, syncId: 0, seeking: false });







  const boundaryAt = current => {







    let low = 0, high = boundaries.length;







    while (low < high) {







      const middle = (low + high) >>> 1;







      if (boundaries[middle] <= current + .005) low = middle + 1;







      else high = middle;







    }







    return low - 1;







  };







  useEffect(() => {







    const previous = parentAnchor.current;







    const stamp = performance.now();







    const elapsed = previous.stamp == null ? 0 : (stamp - previous.stamp) / 1000;







    const expected = previous.time + (controller.current.playing ? elapsed * controller.current.rate : 0);







    const seek = previous.stamp != null && Math.abs(sourceTime - expected) > .6;







    parentAnchor.current = { time: sourceTime, stamp };







    // The media element is authoritative when available; otherwise changes to







    // the parent's time keep the interpolated fallback clock anchored.







    if (!(audioElement ?? audioRef?.current) && seek) {







      controller.current.syncId += 1;







      controller.current.boundary = -2;







      controller.current.time = sourceTime;







      setClock({ now: sourceTime, playing: audioStatus === 'Playing', rate: 1,







        syncId: controller.current.syncId, seeking: true });







    }







  }, [sourceTime, audioElement, audioRef]);







  useEffect(() => {







    const media = audioElement ?? audioRef?.current;







    const playbackChanged = controller.current.playbackId !== playbackId;







    if (!media) {







      const stamp = performance.now();







      const anchor = parentAnchor.current;







      const heldTime = anchor.time + (controller.current.playing && anchor.stamp != null







        ? (stamp-anchor.stamp)/1000*controller.current.rate : 0);







      // Anchor pause/resume to the elapsed clock instead of resetting to zero.







      parentAnchor.current = {time:playbackChanged?sourceTime:heldTime,stamp};







    }







    let frame;







    const read = () => {







      const state = controller.current;







      const playing = media ? !media.paused && !media.ended : audioStatus === 'Playing';







      const rate = media ? media.playbackRate || 1 : 1;







      const anchor = parentAnchor.current;







      const current = media ? Math.max(0, media.currentTime || 0) : Math.max(0,







        anchor.time + (playing && anchor.stamp != null ? (performance.now() - anchor.stamp) / 1000 * rate : 0));







      const boundary = boundaryAt(current);







      return { current, boundary, playing, rate };







    };







    const update = (force = false, seek = false) => {







      const sample = read(), state = controller.current;







      const rateChanged = sample.rate !== state.rate;







      if (seek || rateChanged) state.syncId += 1;







      state.time = sample.current;







      if (force || seek || rateChanged || sample.boundary !== state.boundary || sample.playing !== state.playing) {







        state.boundary = sample.boundary;







        state.playing = sample.playing;







        state.rate = sample.rate;







        setClock({ now: sample.current, playing: sample.playing, rate: sample.rate,







          syncId: state.syncId, seeking: seek || rateChanged });







      }







      return sample.playing;







    };







    const tick = () => { if (update()) frame = requestAnimationFrame(tick); };







    const play = () => { cancelAnimationFrame(frame); update(true); frame = requestAnimationFrame(tick); };







    const stop = () => { cancelAnimationFrame(frame); update(true); };







    const seek = () => { update(true, true); };







    const rate = () => { update(true); };







    const sync = () => { update(); };







    if (media) {







      media.addEventListener('play', play); media.addEventListener('pause', stop);







      media.addEventListener('ended', stop); media.addEventListener('seeked', seek);







      media.addEventListener('ratechange', rate); media.addEventListener('timeupdate', sync);







    }







    if (controller.current.playbackId !== playbackId) {







      controller.current.playbackId = playbackId;







      controller.current.syncId += 1;







    }







    update(true);







    if (read().playing) frame = requestAnimationFrame(tick);







    return () => {







      cancelAnimationFrame(frame);







      if (media) {







        media.removeEventListener('play', play); media.removeEventListener('pause', stop);







        media.removeEventListener('ended', stop); media.removeEventListener('seeked', seek);







        media.removeEventListener('ratechange', rate); media.removeEventListener('timeupdate', sync);







      }







    };







  }, [audioElement, audioRef, playbackId, audioStatus, boundaries]);







  return clock;







}







// Illustrative email content; change the example host and offer details here.







const EXAMPLE_OFFER = {







  host: 'Alex',







  title: 'Museum & Wine Bar',







  date: 'Saturday, October 24',







  time: '2:00 PM',







  location: 'Brentwood, Los Angeles',







  details: 'A museum visit followed by a wine bar · 10 guests',







};







const OFFER_DETAILS = [







  { key:'name', label:'Event name', value:EXAMPLE_OFFER.title, cue:'event name' },







  { key:'date', label:'Date', value:EXAMPLE_OFFER.date, cue:'event date' },







  { key:'time', label:'Start time', value:EXAMPLE_OFFER.time, cue:'start time' },







  { key:'location', label:'Location', value:EXAMPLE_OFFER.location, cue:'meeting point and location' },







  { key:'details', label:'Event details', value:EXAMPLE_OFFER.details, cue:'event details' },







];







// Like ProfileSignals in the reference: replace the copy at important beats,







// keep the mock app mounted, and focus its corresponding zone.







const OFFER_CAPTIONS = [







  { key:'offer', cue:'When we have an event', title:'Receive an offer', detail:'We’ll email you when there’s an event for you to host.' },







  { key:'details', cue:'Start by reviewing', title:'Review the details', detail:'Check the name, date, time, location, and planned activities.' },







  { key:'availability', cue:'Review the offer', title:'Confirm availability', detail:'Reply to let us know whether you can host.' },







];







const OFFER_FOCUS = [







  { key:'offer', cue:'email you an offer' },







  ...OFFER_DETAILS.map(({key,cue})=>({key,cue})),







  { key:'availability', cue:'reply to let us know' },







];







function OfferEmail() {







  return <article className="offer-email" aria-label={`Example email offer from Tribe to ${EXAMPLE_OFFER.host}`}>







    <div className="offer-email-toolbar">







      <span className="offer-email-brand" aria-label="Gmail">







        <svg viewBox="0 0 24 18" aria-hidden="true"><path fill="#4285f4" d="M0 3v13a2 2 0 0 0 2 2h3V6Z"/><path fill="#34a853" d="M19 6v12h3a2 2 0 0 0 2-2V3Z"/><path fill="#ea4335" d="m5 6 7 5 7-5V0l-7 5L5 0Z"/><path fill="#c5221f" d="M0 3 5 6V0L3.2.1A3.2 3.2 0 0 0 0 3Z"/><path fill="#fbbc04" d="m19 6 5-3a3.2 3.2 0 0 0-3.2-2.9L19 0Z"/></svg>







        <span>Gmail</span>







      </span>







      <div className="offer-email-tools" aria-hidden="true"><LuArrowLeft/><span className="offer-email-tool-divider"/><LuArchive/><LuTrash2/><LuMail/><LuEllipsisVertical/></div>







      <span className="offer-email-example">Example offer</span>







    </div>







    <div className="offer-email-content">







      <div className="offer-email-subject offer-scan-zone" data-offer-zone="offer"><h2>Hosting opportunity: {EXAMPLE_OFFER.title}</h2><span>Inbox</span></div>







      <div className="offer-email-sender">







        <span className="offer-email-avatar" aria-hidden="true">T</span>







        <div><strong>Tribe</strong><p>to {EXAMPLE_OFFER.host} <span>▾</span></p></div>







        <span className="offer-email-time">10:24 AM</span>







      </div>







      <div className="offer-email-body">







        <p>Hi {EXAMPLE_OFFER.host},</p>







        <p>We have an event we’d love for you to host:</p>







        <dl className="offer-email-facts">







          {OFFER_DETAILS.map(({ key, label, value }) => <div key={key}







            className="offer-email-fact offer-scan-zone"







            data-offer-zone={key}>







            <dt>{label}</dt><dd><span className="offer-email-highlight">{value}</span></dd>







          </div>)}







        </dl>







        <p className="offer-email-response offer-scan-zone" data-offer-zone="availability">Please reply to let us know if you’re available.</p>







        <p className="offer-email-signature">Thanks,<br/><strong>The Tribe team</strong></p>







      </div>







    </div>







  </article>;







}







const EMAIL_CAMERA={
  offer:{scale:1.035,x:0,y:10},name:{scale:1.07,x:3,y:-8},date:{scale:1.07,x:3,y:-2},
  time:{scale:1.07,x:3,y:4},location:{scale:1.07,x:3,y:10},details:{scale:1.07,x:3,y:16},
  availability:{scale:1.06,x:3,y:21},
};

function CinematicEmail({activeZone}) {
  const stageRef=useRef(null);
  const [focusRect,setFocusRect]=useState(null);
  useLayoutEffect(()=>{
    const stage=stageRef.current;
    if(!stage||!activeZone){setFocusRect(null);return undefined;}
    const measure=()=>{
      const target=stage.querySelector(`.offer-email-source [data-offer-zone="${activeZone}"]`);
      if(!target){setFocusRect(null);return;}
      const outer=stage.getBoundingClientRect(),box=target.getBoundingClientRect();
      const scale=EMAIL_CAMERA[activeZone]?.scale??1;
      setFocusRect({left:(box.left-outer.left)/scale,top:(box.top-outer.top)/scale,width:box.width/scale,height:box.height/scale});
    };
    measure();
    const observer=typeof ResizeObserver==='undefined'?null:new ResizeObserver(measure);
    observer?.observe(stage);window.addEventListener('resize',measure);
    return()=>{observer?.disconnect();window.removeEventListener('resize',measure);};
  },[activeZone]);
  const camera=activeZone?EMAIL_CAMERA[activeZone]??EMAIL_CAMERA.offer:{scale:1,x:0,y:0};
  const stageWidth=stageRef.current?.clientWidth??0,stageHeight=stageRef.current?.clientHeight??0;
  const clip=focusRect?`inset(${focusRect.top}px ${Math.max(0,stageWidth-focusRect.left-focusRect.width)}px ${Math.max(0,stageHeight-focusRect.top-focusRect.height)}px ${focusRect.left}px round 10px)`:null;
  return <div className="offer-cinematic-frame">
    <div className="offer-cinematic-camera" style={{'--email-scale':camera.scale,'--email-x':`${camera.x}px`,'--email-y':`${camera.y}px`}}>
      <div className="offer-cinematic-stage" ref={stageRef}>
        <div className={`offer-email-source ${activeZone?'is-context':''}`}><OfferEmail/></div>
        {activeZone&&focusRect&&<div className="offer-email-crisp" style={{clipPath:clip}} aria-hidden="true"><OfferEmail/></div>}
        {activeZone&&focusRect&&<span className="offer-focus-edge" style={{left:focusRect.left,top:focusRect.top,width:focusRect.width,height:focusRect.height}} aria-hidden="true"/>}
      </div>
    </div>
  </div>;
}

function EventOfferScene(props) {







  const { duration=0, wordTimings=props.words ?? EMPTY_TIMINGS, audioStatus, playbackId=0 }=props;







  const narration=EventOffer.parts[1].narration;







  const timeline=useNarrationTimeline(narration,wordTimings,duration);







  const clock=useLessonClock(props,timeline);







  const {now,seeking}=clock;







  const complete=audioStatus==='Complete' || Boolean((props.audioElement ?? props.audioRef?.current)?.ended);







  const captions=useMemo(()=>OFFER_CAPTIONS.map(item=>({...item,start:cueTime(narration,timeline,item.cue)})),[narration,timeline]);







  const focus=useMemo(()=>OFFER_FOCUS.map(item=>({...item,start:cueTime(narration,timeline,item.cue)})),[narration,timeline]);







  const caption=captions[complete?captions.length-1:activeIndex(captions,now)];







  const activeZone=complete || now < focus[0].start ? null : focus[activeIndex(focus,now)].key;







  return <section className={`host-offer-scene ${complete?'is-reviewing':''} ${seeking?'is-seeking':''}`}







      data-timing-mode={timeline.mode}>







      <div className="offer-composition">







        <div className="offer-caption" key={`${playbackId}-${caption.key}-${clock.syncId}`} style={{







          animationDuration:`${.4/clock.rate}s`,







          animationPlayState:complete || clock.playing?'running':'paused',







          animationDelay:seeking || complete?'-10s':'0s',







        }}>







          <h1>{caption.title}</h1>







          <p>{caption.detail}</p>







        </div>







        <span className="offer-composition-divider" aria-hidden="true" />







        <div className="offer-email-pane"><CinematicEmail activeZone={activeZone} /></div>







      </div>







    </section>;







}







const OFFER_INTRO_CUES = [



  'Now that we’ve covered the basics,',



  'let’s walk through how you’re assigned an event,',



  'what information you’ll receive in your event guide,',



'and how to welcome and check in guests using the Tribe web app.',



];







function EventOfferIntro(props) {



  const narration = EventOffer.parts[0].narration;



  const timeline = useNarrationTimeline(narration, props.wordTimings ?? props.words ?? EMPTY_TIMINGS, props.duration ?? 0);



  const clock = useLessonClock(props, timeline);



  const beats = useMemo(() => buildBeats(narration, timeline, OFFER_INTRO_CUES), [narration, timeline]);



  const complete = props.audioStatus === 'Complete' || Boolean((props.audioElement ?? props.audioRef?.current)?.ended);



  const sceneIndex = complete ? beats.length - 1 : activeIndex(beats, clock.now);



  const scene = beats[sceneIndex];



  const words = scene.text.split(/\s+/).filter(Boolean);



  const settled = useMemo(() => clock.seeking || (!clock.playing && clock.now > scene.start), [clock.syncId, sceneIndex]);



  return <section className="offer-intro-scene" data-timing-mode={timeline.mode}>



    <h1 key={`${props.playbackId ?? 0}-${sceneIndex}-${clock.syncId}`} aria-label={scene.text}>



      {words.map((word, index) => <React.Fragment key={index}>



        <span className="offer-intro-word" aria-hidden="true" style={{



          animationDelay: `${complete || settled ? -10 : index * .09 / clock.rate}s`,



          animationDuration: `${.38 / clock.rate}s`,



          animationPlayState: complete || clock.playing ? 'running' : 'paused',



        }}>{word}</span>{index < words.length - 1 ? ' ' : ''}



      </React.Fragment>)}



    </h1>



  </section>;



}







export default function EventOffer(props={}) {



  const part = Number(props.part) === 1 ? 1 : 0;







  return <div className="host-background-slide host-event-offer" aria-label={EventOffer.title}>







    <style>{FONT_IMPORT + OFFER_STYLES + EMAIL_STYLES}</style>







    {part === 0 ? <EventOfferIntro {...props} key="intro" /> : <EventOfferScene {...props} key="offer" />}







  </div>;







}







const FONT_IMPORT="@import url('https://fonts.googleapis.com/css2?family=Merriweather:wght@700&display=swap');";







const OFFER_STYLES=`



.host-event-offer .offer-intro-scene {min-height:530px;padding:36px 40px;display:flex;align-items:center;justify-content:center;}



.host-event-offer .offer-intro-scene h1 {max-width:820px;margin:0;text-align:center;font-family:Merriweather,Georgia,serif;font-size:clamp(28px,3.6vw,44px);font-weight:700;line-height:1.2;letter-spacing:-.025em;}



.host-event-offer .offer-intro-word {display:inline-block;opacity:0;transform:translateY(.36em);animation:offer-intro-word-in 380ms cubic-bezier(.18,.84,.22,1) both;}



@keyframes offer-intro-word-in {to {opacity:1;transform:translateY(0);}}



@media(max-width:600px){.host-event-offer .offer-intro-scene {min-height:420px;padding:28px 22px;}.host-event-offer .offer-intro-scene h1 {font-size:28px;}}



@media(prefers-reduced-motion:reduce){.host-event-offer .offer-intro-word {animation:none!important;opacity:1;transform:none;}}











.host-event-offer {width:100%;background:#fff;color:#111;font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;}







.host-event-offer * {box-sizing:border-box;}







.host-event-offer .host-offer-scene {min-height:530px;padding:36px 40px 40px;}







.host-training .ht-lesson-layout:has(.host-event-offer) {display:block;padding:0;}







.host-training .ht-lesson-layout:has(.host-event-offer)>.ht-lesson-copy {display:none;}







.host-training .ht-lesson-visual:has(.host-event-offer) {display:block;padding:0;background:#fff;border:0;border-radius:0;}







@media(min-width:701px) and (max-width:900px){







  .host-event-offer .host-offer-scene {padding-left:24px;padding-right:24px;}







}







@media(max-width:700px){







  .host-event-offer .host-offer-scene {min-height:540px;padding:28px 20px 32px;}







}







`;







const EMAIL_STYLES=`







.host-event-offer .offer-composition {display:grid;grid-template-columns:minmax(260px,.9fr) 1px minmax(320px,1.1fr);align-items:center;gap:var(--ht-split-gap,clamp(17px,3.5vw,43px));width:min(var(--ht-split-max,1000px),100%);min-height:580px;margin:0 auto;}







.host-event-offer .offer-caption {min-width:0;text-align:left;animation:offer-copy-in 400ms ease both;}







.host-event-offer .offer-caption h1 {max-width:430px;margin:0;font-family:Merriweather,Georgia,serif;font-size:clamp(29px,3.25vw,40px);font-weight:700;line-height:1.12;letter-spacing:-.025em;}







.host-event-offer .offer-caption p {max-width:360px;margin:18px 0 0;color:#626262;font-size:13px;line-height:1.5;}







.host-event-offer .offer-composition-divider {align-self:stretch;width:1px;background:var(--ht-divider,#dedede);margin:20px 0;}







.host-event-offer .offer-email-pane {min-width:0;}

.host-event-offer .offer-cinematic-frame {position:relative;overflow:hidden;margin:-12px;padding:12px;border-radius:16px;}

.host-event-offer .offer-cinematic-camera {transform:translate(var(--email-x),var(--email-y)) scale(var(--email-scale));transform-origin:50% 50%;transition:transform 620ms cubic-bezier(.2,.75,.2,1);}

.host-event-offer .offer-cinematic-stage {position:relative;}

.host-event-offer .offer-email-source {position:relative;z-index:1;transition:filter 360ms ease,opacity 360ms ease;}

.host-event-offer .offer-email-source.is-context {filter:blur(2.4px);opacity:.32;}

.host-event-offer .offer-email-crisp {position:absolute;inset:0;z-index:2;pointer-events:none;}

.host-event-offer .offer-focus-edge {position:absolute;z-index:3;border-radius:10px;box-shadow:0 0 0 1px #ffffffd9,0 12px 28px #11111112;pointer-events:none;transition:left 440ms cubic-bezier(.2,.75,.2,1),top 440ms cubic-bezier(.2,.75,.2,1),width 440ms cubic-bezier(.2,.75,.2,1),height 440ms cubic-bezier(.2,.75,.2,1);}







.host-event-offer .offer-email-pane .offer-email {max-width:none;margin:0;animation:none;}







.host-event-offer .offer-email-pane .offer-email-subject h2 {min-width:0;overflow:hidden;text-overflow:ellipsis;font-size:clamp(12px,1.4vw,15px);}







.host-event-offer .offer-email-pane .offer-email-subject > span {flex:none;}







.host-event-offer .offer-email-pane .offer-email-toolbar {gap:12px;padding:12px 15px;}







.host-event-offer .offer-email-pane .offer-email-tools {gap:12px;}







.host-event-offer .offer-email-pane .offer-email-tools svg:nth-last-child(-n+2) {display:none;}







.host-event-offer .offer-email-pane .offer-email-brand {font-size:17px;}







.host-event-offer .offer-email-pane .offer-email-example {font-size:8px;letter-spacing:.03em;}







.host-event-offer .offer-email-pane .offer-email-content {padding:20px 16px;}







.host-event-offer .offer-email-pane .offer-email-body {margin-left:0;font-size:12px;}







.host-event-offer .offer-email-pane .offer-email-fact {grid-template-columns:85px 1fr;}







@keyframes offer-copy-in {from{opacity:0}to{opacity:1}}







.host-event-offer .offer-email {max-width:790px;margin:30px auto 0;background:#fff;border:1px solid #dedede;border-radius:14px;overflow:hidden;animation:offer-email-enter .28s ease both;}







.host-event-offer .offer-email-toolbar {display:flex;align-items:center;gap:28px;padding:12px 22px;background:#f7f8fa;border-bottom:1px solid #e8e9ec;}







.host-event-offer .offer-email-brand {display:inline-flex;align-items:center;gap:9px;color:#5f6368;font-size:20px;letter-spacing:-.5px;}







.host-event-offer .offer-email-brand svg {width:25px;height:19px;}







.host-event-offer .offer-email-tools {display:flex;align-items:center;gap:20px;color:#6b7075;}







.host-event-offer .offer-email-tools svg {width:17px;height:17px;stroke-width:1.6;}







.host-event-offer .offer-email-tool-divider {width:1px;height:17px;background:#dedfe2;}







.host-event-offer .offer-email-example {margin-left:auto;color:#777;font-size:10px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;white-space:nowrap;}







.host-event-offer .offer-email-content {padding:20px 28px 22px;}







.host-event-offer .offer-email-subject {display:flex;align-items:center;gap:12px;margin-bottom:18px;padding-left:12px;}







.host-event-offer .offer-email-subject h2 {margin:0;font-size:20px;line-height:1.45;letter-spacing:-.035em;font-weight:500;white-space:nowrap;}







.host-event-offer .offer-email-subject > span {padding:3px 6px;border-radius:3px;background:#eceff1;color:#65686c;font-size:10px;}







.host-event-offer .offer-email-sender {display:flex;align-items:center;gap:12px;}







.host-event-offer .offer-email-avatar {display:grid;place-items:center;flex:none;width:36px;height:36px;border-radius:50%;background:#f0f0f0;font-size:16px;font-weight:600;color:#555;}







.host-event-offer .offer-email-sender strong {font-size:13px;font-weight:600;}







.host-event-offer .offer-email-sender p {margin:3px 0 0;color:#777;font-size:11px;}







.host-event-offer .offer-email-sender p span {margin-left:4px;}







.host-event-offer .offer-email-time {margin-left:auto;align-self:flex-start;padding-top:5px;color:#888;font-size:10px;}







.host-event-offer .offer-email-body {margin-left:48px;max-width:590px;color:#333;font-size:13px;line-height:1.6;}







.host-event-offer .offer-email-body > p {margin:12px 0 0;}







.host-event-offer .offer-email-facts {margin:10px 0 14px;}







.host-event-offer .offer-email-fact {display:grid;grid-template-columns:100px 1fr;align-items:baseline;padding:4px 0;}







.host-event-offer .offer-email-fact dt {font-size:12px;font-weight:600;color:#646464;}







.host-event-offer .offer-email-fact dd {margin:0;}







.host-event-offer .offer-email-highlight {padding:3px 6px;margin-left:-6px;border-radius:3px;background:transparent;box-decoration-break:clone;-webkit-box-decoration-break:clone;transition:background-color .16s ease,color .16s ease;}







.host-event-offer .offer-scan-zone {position:relative;border:1px solid transparent;border-radius:10px;transition:opacity 420ms ease,background-color 420ms ease,box-shadow 420ms ease;}







.host-event-offer .offer-email-subject.offer-scan-zone {padding-top:6px;padding-bottom:6px;margin-top:-6px;}







.host-event-offer .offer-email-fact.offer-scan-zone {padding:5px 7px;margin-left:-7px;margin-right:-7px;}







.host-event-offer .offer-email-response {padding:5px 7px;margin-left:-7px!important;margin-right:-7px!important;}







.host-event-offer .is-seeking .offer-scan-zone {transition:none;}

.host-event-offer .is-seeking .offer-cinematic-camera,.host-event-offer .is-seeking .offer-email-source,.host-event-offer .is-seeking .offer-focus-edge {transition:none;}







.host-event-offer .offer-email-signature {color:#656565;}







.host-event-offer .offer-email-signature strong {font-weight:500;color:#333;}







.host-event-offer .is-seeking .offer-email {animation:none;}







@keyframes offer-email-enter {from{opacity:0;transform:translateY(5px)}to{opacity:1;transform:translateY(0)}}







@media(max-width:700px) {







  .host-event-offer .offer-composition {grid-template-columns:1fr;gap:24px;width:min(460px,100%);min-height:360px;}







  .host-event-offer .offer-caption {text-align:center;}







  .host-event-offer .offer-caption h1,.host-event-offer .offer-caption p {margin-left:auto;margin-right:auto;}







  .host-event-offer .offer-caption h1 {font-size:31px;}







  .host-event-offer .offer-caption p {margin-top:10px;font-size:12px;}







  .host-event-offer .offer-composition-divider {height:1px;width:100%;margin:0;}







  .host-event-offer .offer-email-pane .offer-email-subject h2 {font-size:clamp(11px,2.75vw,15px);}







  .host-event-offer .offer-email {margin-top:25px;}







  .host-event-offer .offer-email-toolbar {padding:12px 15px;gap:18px;}







  .host-event-offer .offer-email-tools {gap:13px;}







  .host-event-offer .offer-email-tools svg:nth-last-child(-n+2) {display:none;}







  .host-event-offer .offer-email-brand {font-size:17px;}







  .host-event-offer .offer-email-example {font-size:8px;letter-spacing:.03em;}







  .host-event-offer .offer-email-content {padding:20px 16px;}







  .host-event-offer .offer-email-subject {gap:8px;margin-bottom:20px;}







  .host-event-offer .offer-email-subject h2 {font-size:clamp(11px,2.75vw,18px);letter-spacing:-.035em;}







  .host-event-offer .offer-email-subject > span {font-size:8px;}







  .host-event-offer .offer-email-body {margin-left:0;font-size:12px;}







  .host-event-offer .offer-email-fact {grid-template-columns:85px 1fr;}







  .host-event-offer .offer-email-fact dt {font-size:11px;}







}







@media(prefers-reduced-motion:reduce) {







  .host-event-offer .offer-email {animation:none;}







  .host-event-offer .offer-scan-zone {transition:none;}







  .host-event-offer .offer-caption {animation:none!important;opacity:1;transform:none;clip-path:none;}







}







`;







Object.assign(EventOffer, {







  slide:5,







  id:'event-offer',







  title:'Event Offer',







  section:'Before an Event',







  parts:[{part:0,narration:"Now that we’ve covered the basics, let’s walk through how you’re assigned an event, what information you’ll receive in your event guide, and how to welcome and check in guests using the Tribe web app."},{part:1,narration:'When we have an event for you to host, we’ll email you an offer.\n\nStart by reviewing the event name. In this example, it’s Museum and Wine Bar.\n\nNext, check the event date and make sure that day is free.\n\nThen check the start time and confirm it works with your schedule.\n\nReview the meeting point and location, so you know where to meet the group.\n\nFinally, read the event details to understand the activities you’ll be leading.\n\nReview the offer and reply to let us know whether you’re available to host. Once you confirm, we’ll assign you to the event and send you the event guide.'}],







  summary:['Review the details.','Confirm whether you are available.','Receive your event guide.'],







});
